<template>
  <q-page class="flex flex-center">
    <SigninForm />
  </q-page>
</template>

<script>
import SigninForm from '../components/SigninForm.vue';

export default {
  name: "SigninPage",
  components: {
    SigninForm,
  },
};
</script>
